<script>
  import loginServico from './servico';
  import mixinPosLogin from '~js/destino-pos-login';
  import radio from '~componentes/Radio.vue';

  export default {
    mixins: [mixinPosLogin],
    components: { radio },
    data() {
      return {
        usuario: {},
        mostrarErroUsuario: false, 
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar: function () {
        this.$validator.validateAll();

        if (!this.errors.any()) {
          this.login()
        }
      },
      login: function () {
        this.mostrarErroUsuario = false;
        
        $('.btn').button('loading');

        loginServico.acessoEspecial(this.usuario)
          .then(resposta => {
            this.$storage.usuario(resposta.body.usuario);
            this.$storage.token(resposta.body.token);
          })
          .then(() => {
            this.irParaDestinoPosLogin('/');
          })
          .catch(erro => {
            $('.btn').button('reset');
            
            if (erro.status === 404) {
              this.mostrarErroUsuario = true;
            } else if (erro.status === 401) {
              this.$swal('', erro.body.message, 'warning');
            } else {
              this.$swal('', 'Ocorreu um erro no login, caso o erro persista entre em contato com a fundação.', 'error');
            }
            this.$router.push('/login/acesso-especial');
          });
      },
    },
    mounted() {
    },
    watch: {

    }
  }
</script>

<template>
  <div>
    <form class="m-t" role="form" @submit.prevent="validar">
      <div class="alert alert-danger" role="alert" v-show="mostrarErroUsuario">Usuário ou senha incorreto(s).</div>
      
      <div class="form-group" :class="{ 'has-error': errors.has('usuario') }">
        <input 
            type="text" 
            class="form-control" 
            placeholder="Usuário" 
            name="usuario" 
            id="usuario"
            v-model="usuario.login"
            v-validate="`required`">

        <p class="text-danger" v-if="errors.has('usuario')">{{ errors.first('usuario') }}</p>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('senha') }">
        <input 
            type="password" 
            class="form-control" 
            placeholder="*******" 
            name="senha" 
            v-model="usuario.senha" 
            v-validate="'required'">
               
          <p class="text-danger" v-if="errors.has('senha')">{{ errors.first('senha') }}</p>
      </div>
      <button 
          type="submit" 
          class="btn btn-primary block full-width m-b" 
          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Entrando...">
        Entrar
      </button>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/login/LoginAcessoEspecial.vue